module.exports = __webpack_public_path__ + "static/media/pause.7a975d4b.svg";